"use client";

import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/lib/query-keys";
import {
  getAdminContactByIdAction,
  getAdminContactsAction,
} from "@/resources/actions/admin.actions";
import type { GetAdminContactsRequest } from "@/resources/interfaces";

export function useAdminContacts(params?: GetAdminContactsRequest) {
  return useQuery({
    queryKey: queryKeys.admin.contact.list(params as Record<string, unknown>),
    queryFn: async () => {
      const result = await getAdminContactsAction(params);
      if (result.error) throw new Error(result.error);
      return result.data;
    },
    staleTime: 0,
  });
}

export function useAdminContactById(id?: string) {
  return useQuery({
    queryKey: queryKeys.admin.contact.detail(id ?? ""),
    queryFn: async () => {
      const result = await getAdminContactByIdAction(id ?? "");
      if (result.error) throw new Error(result.error);
      return result.data;
    },
    enabled: !!id,
    staleTime: 1000 * 60 * 2,
  });
}
